/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import {
  init,
  addBreadcrumb,
  captureMessage,
  captureException,
  configureScope,
  withScope,
  Breadcrumb,
  User,
} from '@sentry/browser';
import { BreadcrumbHint, EventHint, Event } from '@sentry/types';
import { Middleware, Store } from 'redux';

import config from '../config';

let store: Store | undefined; // Updated on registering store.
const release = process.env.REACT_APP_RELEASE_ID || undefined;
const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  init({
    dsn: config.sentry.dsn,
    release,
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    beforeBreadcrumb: (breadcrumb: Breadcrumb, hint?: BreadcrumbHint) => {
      const { category, data } = breadcrumb;
      // Ignore very noisy successful fetches of OSF frames / poses
      if (category === 'fetch' || category === 'xhr') {
        if (data.status_code === 200 && data.url.indexOf('drive-osf') > -1) {
          return null;
        }
      }

      return breadcrumb;
    },
    beforeSend: (event: Event, hint?: EventHint) => {
      if (store) {
        try {
          const state = store.getState();
          event.extra = event.extra || {};
          event.extra = {
            ...event.extra,
            'Redux State': state,
          };
          // TODO: Check if payload size would be too large.
          // TODO: Any custom state pruning can go here.
        } catch (err) {
          console.warn('Failed to serialize redux store.');
        }
      }

      // Batch together OSF request errors
      if (hint && hint.originalException instanceof Error) {
        const msg = hint.originalException.message;
        const isPngOsfFailure = msg.includes('png request failed');
        const isJsonOsfFailure = msg.includes('json request failed');
        if (isPngOsfFailure || isJsonOsfFailure) {
          event.fingerprint = ['OSF Frame Request Error'];
        }
      }

      return event;
    },
  });
}

const logger = {
  error: (errOrMsg: string | Error, fingerprint?: string[]) => {
    if (isProd) {
      withScope((scope) => {
        if (fingerprint) {
          scope.setFingerprint(fingerprint);
        }

        // Report up to sentry
        if (errOrMsg instanceof Error) {
          captureException(errOrMsg);
        } else if (typeof errOrMsg === 'string') {
          captureMessage(errOrMsg);
        }

        // Also log to console.
        console.error(errOrMsg);
      });
    } else {
      console.error(errOrMsg);
    }
  },
};

/**
 *
 * @param user
 */
export function setUser(user: User) {
  if (isProd) {
    configureScope((scope) => scope.setUser(user));
  }
}

export const sentryBreadcrumbMiddleware: Middleware =
  () => (next) => (action) => {
    if (isProd) {
      addBreadcrumb({
        category: 'redux',
        message: action.type,
      });
    }
    return next(action);
  };

// TODO: Type this
export const registerStore = (storeToRegister: Store) => {
  store = storeToRegister;
};

export default logger;
